export const frChallenges = {
    'navbar.challenges': 'Challenges',
    'challenges.name': 'Challenge',
    'challenges.title': 'Challenges',

    //* CHALLENGE LIST
    'challenges.list.pageTitle': 'Challenges',
    'challenges.list.actions.addChallenges': 'Créer un challenge',
    'challenges.list.table.emptyLabel': "Il n'y a pas de challenge pour le moment",

    //* CHALLENGE INFORMATIONS
    'challenges.info.description': 'Saisissez ici la description du challenge',
    'challenges.info.owner.select.title': 'Sélectionnez le propriètre du challenge',
    'challenges.info.dates.start': 'Date de début',
    'challenges.info.dates.end': 'Date de fin',

    //* CHALLENGE SCORE // DEFINITION DU SCORE
    'challenges.score.def.sectionTitle': 'DEFINITION DU SCORE',
    'challenges.score.def.label': 'Libellé du score *',
    'challenges.score.def.placeholder': 'Chiffres d’affaires',
    'challenges.score.def.unit': 'Unité *',
    'challenges.score.def.unit.hint': 'Sélectionnez un type de score',

    'challenges.score.def.unit.label.Price': 'Montant : €',
    'challenges.score.def.unit.label.Percent': 'Pourcentage : %',
    'challenges.score.def.unit.label.Quantity': 'Quantité',
    'challenges.score.def.unit.label.Point': 'Points : pts',

    'challenges.score.rankingChallengeOrder.Ascending.title': 'Classement croissant : ',
    'challenges.score.rankingChallengeOrder.Ascending.desc': 'le plus petit est 1er',
    'challenges.score.rankingChallengeOrder.Descending.title': 'Classement décroissant : ',
    'challenges.score.rankingChallengeOrder.Descending.desc': 'le plus grand est 1er',

    //* CHALLENGE SCORE // MANUAL IMPORT
    'challenges.score.manual.sectionTitle': 'Import manuelle',
    'challenges.score.manual.updateRanking':
        'Mettre à jour le classement en important un fichier EXCEL',
    'challenges.score.manual.actions.import': 'Importer',
    'challenges.score.manual.actions.export': 'Exporter le modèle',

    'challenges.score.manual.import.success': 'Import du classement réalisé avec succès !',

    //* CHALLENGE SCORE // HISTORIQUE DES IMPORTS
    'challenges.score.import.sectionTitle': 'Historique des imports',
    'challenges.score.import.tab.date': "Date de l'import",
    'challenges.score.import.tab.shops': 'Nombre de centres',
    'challenges.score.import.tab.type': 'Type',
    'challenges.score.import.tab.user': 'Utilisateur',
    'challenges.score.import.tab.delete': 'Supprimer',
    'challenges.score.import.tab.importHistoryEmpty': "Pas d'historique d'import",
    'challenges.score.import.tab.type.Manual': 'Manuel',
    'challenges.score.import.tab.type.Progress': 'Automatique',
    'challenges.score.import.tab.type.Turnover': 'Automatique',
    'challenges.score.import.tab.dateFormat': 'dd/MM/yyyy à HH:mm',
    'challenges.score.import.importNewFile': 'Import un nouveau fichier',

    //* CHALLENGE SCORE // SYNCHRONISATION AUTOMATIQUE
    'challenges.score.sync.sectionTitle': 'Synchronisation automatique',
    'challenges.score.sync.type': 'Type de données du challenge',
    'challenges.score.sync.type.Turnover': 'Chiffre d’affaires (€)',
    'challenges.score.sync.type.Progress': 'Progression (%)',
    'challenges.score.sync.frequency': 'Fréquence de synchronisation',
    'challenges.score.sync.hour': 'Heure',

    //* CHALLENGE AUDIENCE DEFINITION
    'challenges.audiences.def.title':
        'Ce challenge peut mettre en compétition des centres uniquement ou à certains rôles des collaborateurs.',
    'challenges.audiences.def.subtitle': 'Sélectionnez votre type d’audience : ',

    'challenges.audiences.def.type.shop.title': 'Challenge Centre',
    'challenges.audiences.def.type.shop.subtitle': '(1 résultat par centre)',

    'challenges.audiences.def.type.collaborator.title': 'Challenge Collaborateur',
    'challenges.audiences.def.type.collaborator.subtitle':
        '(1 résultat par collaborateur sélectionné)',

    'challenges.audiences.collaborator.selectRoles':
        "Il s'agit d'un challenge collaborateurs, sélectionnez les rôles des collaborateurs participants au challenge :",

    //* CHALLENGE NOTIFICATIONS // AUTOMATIC
    'challenges.notification.automatic.sectionTitle': 'Notification automatique',
    'challenges.notification.automatic.notifyUpdates':
        'Définir le mode de notification des mises à jour du classement',

    'challenges.notification.automatic.mode.Reccurent': 'Périodique',
    'challenges.notification.automatic.mode.Publication':
        'A chaque publication d’un nouveau classement',

    'challenges.notification.recurrent.time': 'Heure',

    //* CHALLENGE NOTIFICATIONS // MANUAL
    'challenges.notification.manual.sectionTitle': 'Notification manuelle',
    'challenges.notification.manual.notifyShops':
        'Envoyer une notification à tous les centres participant au challenge',

    'challenges.notification.manual.remindAction': 'Notifier',

    'challenges.notification.remind.type.RankingUpdate': 'Mise à jour de classement',
    'challenges.notification.remind.type.EndOfChallenge': 'Fin de challenge',

    //* CHALLENGE NOTIFICATIONS // HISTORY
    'challenges.notification.history.sectionTitle': 'Historique des notifications',

    'challenges.notification.history.table.header.date': 'Date de la notification',
    'challenges.notification.history.table.header.content': 'Contenu',
    'challenges.notification.history.table.header.type': 'Type',
    'challenges.notification.history.table.header.user': 'Utilisateur',
    'challenges.notification.history.table.header.shops': 'Nombre de centres',

    'challenges.notification.history.dateFormat': 'dd/MM/yyyy',

    'challenges.notification.history.type.manual': 'Manuel',
    'challenges.notification.history.type.recurrent': 'Automatique',
    'challenges.notification.history.type.on_event': 'Automatique',
    'challenges.notification.history.type.on_publish': 'Publication',

    'challenges.notification.history.content.ChallengeRankingUpdated': 'Classement mis à jour',
    'challenges.notification.history.content.ChallengeEnd': 'Fin du challenge',

    'challenges.notification.history.notifsHistoryEmpty': "Pas d'historique de notifications",

    //* CHALLENGE >> CREATE AND DETAILS
    'challenges.create.pageTitle': 'Création challenge',
    'challenges.details.pageTitle': 'Détails challenge',
    'challenges.details.actions.previous': 'Challenges',
    'challenges.content.tabs.score': 'Score',

    'challenges.info.input.title': 'Saisissez ici le titre du challenge *',
    'challenges.info.input.code': 'Saisissez ici le code du challenge',

    'challenges.remove.dialog.title': 'Suppression du challenge',
    'challenges.remove.dialog.content': 'Êtes-vous sûr de vouloir supprimer ce challenge ?',
    'challenges.import.remove.dialog.title': "Suppression de l'import",
    'challenges.import.remove.dialog.content':
        'Êtes-vous sûr de vouloir supprimer cet import ?',

    //* CHALLENGE DETAILS //TABS //RESULTS
    'challenges.details.results.tableHeader.rank': 'Rang',
    'challenges.details.results.tableHeader.user': 'Utilisateur',
    'challenges.details.results.tableHeader.shop': 'Centre',
    'challenges.details.results.tableHeader.shops': 'Centres',
    'challenges.details.results.tableHeader.score': 'Score',
    'challenges.details.results.tableHeader.evolution': 'Evolution',

    'challenges.details.results.evolution.up': '+{value}',
    'challenges.details.results.evolution.unchanged': '-',

    'challenges.details.results.emptyLabel': 'Aucun résultat pour le moment.',

    //* PERMISSIONS
    'backofficeUsers.create.tabs.permissions.sectionTabs.challenges': 'Challenges',
    'backofficeUsers.permissions.challenges.contentcreate':
        'Création de challenge',

    //* ERRORS
    'toast.apiErrors.CHALLENGE_NOT_PUBLISHED':
        "Ce challenge n'est pas publié, vous ne pouvez pas notifier les utilisateurs",
    'toast.apiErrors.CHALLENGE_MISSING_AUDIENCE': "Ce challenge n'a pas d'audience défini",
    'toast.apiErrors.CHALLENGE_MISSING_DATE': "Il n'y a pas de date définie pour ce contenu",
    'toast.apiErrors.CHALLENGE_SCORE_INVALID_FOR_TARGET':
        'Les scores des utilisateurs ne sont pas renseignés',
    'toast.apiErrors.CHALLENGE_MISSING_SCORE_TITLE': "Le score du challenge n'est pas défini",
    'toast.apiErrors.CHALLENGE_MISSING_SCORING_UNIT':
        "L'unité du score du challenge n'est pas défini",

    'toast.apiErrors.CHALLENGE_ALREADY_PUBLISHED': 'Ce challenge est déjà publié',
};
